<div class="switch-container" (click)="toggleSwitch()">
  <div class="switch-option" [class.active]="activeOption === 1">
    Залишки на Локації
  </div>
  <div class="switch-option" [class.active]="activeOption === 2">
    МНН-сфокусований вид
  </div>
</div>
